/// <reference path="../../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemeEnrollmentSelectGrid extends _Ext.GridBase<SchemeEnrollmentRow, any> {
        protected getColumnsKey() { return 'Scheme.SchemeSelect'; }
        protected getDialogType() { return SchemeEnrollmentDialog; }
        protected getIdProperty() { return SchemeEnrollmentRow.idProperty; }
        protected getInsertPermission() { return SchemeEnrollmentRow.insertPermission; }
        protected getLocalTextPrefix() { return SchemeEnrollmentRow.localTextPrefix; }
        protected getService() { return SchemeSelectService.baseUrl; } 
        private autoSize;


        
        constructor(container: JQuery,options) {
            super(container, options);
            var poscustomerid = options.GridFilters.CustomerId;
            var request = this.view.params as Serenity.ListRequest;
            if (poscustomerid > 0)
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [['CustomerId'], '=', poscustomerid]);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

      
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): SchemeEnrollmentRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
         
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}